import type { BreakdownGroup } from '../../lib/types';
import { formatBR } from '../../lib/utils';

export interface BreakdownBarProps {
  item: BreakdownGroup;
  max: number;
  accent: string;
  colorFor?: (slug: string) => string;
}

export function BreakdownBar({ item, max, accent, colorFor }: BreakdownBarProps) {
  const pct = max > 0 ? (item.scaled / max) * 100 : 0;
  const segments = item.segments ?? [];
  const stacked = segments.length > 1 && !!colorFor;
  return (
    <div
      className="flex items-center gap-2 px-3 sm:px-3.5 py-1"
      data-testid="breakdown-bar"
    >
      <span
        className="w-20 sm:w-28 flex-shrink-0 truncate font-mono text-[10.5px] text-text"
        title={item.key}
      >
        {item.key}
      </span>
      <div className="relative h-2 flex-1 overflow-hidden rounded bg-surfaceAlt">
        {stacked ? (
          <div
            className="absolute inset-y-0 left-0 flex overflow-hidden rounded"
            style={{ width: `${pct}%` }}
          >
            {segments.map(s => (
              <div
                key={s.key}
                data-testid="breakdown-segment"
                title={`${s.key} · ${formatBR(s.scaled)}`}
                style={{ flexGrow: s.scaled, background: colorFor!(s.key) }}
              />
            ))}
          </div>
        ) : (
          <div
            className="absolute inset-y-0 left-0 rounded"
            style={{ width: `${pct}%`, background: accent }}
          />
        )}
      </div>
      <span className="w-10 sm:w-12 flex-shrink-0 text-right font-mono text-[10.5px] tabular-nums text-textMute">
        {formatBR(item.scaled)}
      </span>
    </div>
  );
}

export default BreakdownBar;
